import { usingGet } from '@ocean/api'

export const getServiceRecordDetails = (
  competenceId: Guid,
  serviceRecordId: Guid,
  resultId?: Guid
) => {
  const baseUrl = `serviceRecords/details/${competenceId}/${serviceRecordId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
